export default __webpack_public_path__ + "static/media/wizard_river.9516244d.gif";